// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__34zoF","bigColWidth":"Table_bigColWidth__1qd4C","biggerColWidth":"Table_biggerColWidth__1tDZP","row":"Table_row__2FG8C","col":"Table_col__38zIr"};